import type { IconData } from '@stacksjs/iconify-core'

export const pizzaSlice: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.258 6.884L9.97 16.977l5.618-9.83c-1.33-.105-2.712-.453-4.242-.992c-.395-.14-.598-.171-.78-.148c-.154.02-1.723.569-2.643.802q-1.743.44-3.665.075m-1.41-2.49c1.702.67 3.224.82 4.584.476c.738-.187 2.478-.796 2.883-.847c.529-.067 1.03.01 1.696.245c1.774.626 3.296.956 4.703.909l.887-1.552A18.6 18.6 0 0 0 9.966 2a18.6 18.6 0 0 0-7.569 1.596l.451.797zM.542 2.268A20.5 20.5 0 0 1 9.966 0c3.362 0 6.606.8 9.496 2.306a1 1 0 0 1 .406 1.383l-9.034 15.807a1 1 0 0 1-1.738-.004L.13 3.65a1 1 0 0 1 .412-1.38zM8 10a1 1 0 1 1 0-2a1 1 0 0 1 0 2m3 3a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pizzaSlice
